import React, {useMemo} from "react";
import PropTypes from "prop-types";
import DrawerItemIcon from "components/Shared/MSidebar/DrawerItemIcon";
import DrawerItemRightSide from "components/Shared/MSidebar/DrawerItemRightSide";
import DrawerItemTitle from "components/Shared/MSidebar/DrawerItemTitle";

const DrawerItem = ({
  icon,
  title,
  isCurrentPath,
  children,
  iconOnClick,
}) => {
  const className = useMemo(
    () => isCurrentPath ? "DrawerItem-isCurrentPath" : "",
    [isCurrentPath]
  );
  return (
    <div className={`DrawerItem-Root ${className}`}>
      <DrawerItemIcon 
        {...{isCurrentPath, icon, iconOnClick, title}}
      />
      <DrawerItemRightSide
        children={children || <DrawerItemTitle {...{isCurrentPath, title}}/>}
      />
    </div>
  );
};

DrawerItem.defaultProps = {
  title: "",
  isCurrentPath: false,
  children: null,
  iconOnClick: () => {},
};

DrawerItem.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
  isCurrentPath: PropTypes.bool,
  children: PropTypes.node,
  iconOnClick: PropTypes.func,
};

export default DrawerItem;